<template>
  <div>
    <div :style="{ height: isOpen ? (maxHeight + 'px') : '0' }" class="more-data">
      <div ref="moreData">
        <slot></slot>
      </div>
    </div>
    <div
      :style="getStyle"
      :class="`more-icon ${ isOpen ? 'icon-down' : 'icon-up' }`" @click="handleClick">
      <i class="allIconFont">&#xe6d0;</i>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      maxHeight: 0
    }
  },
  props: {
    defaultOpen: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    getStyle () {
      return {
        textAlign: this.textAlign
      }
    }
  },
  mounted () {
    if (this.defaultOpen) {
      this.isOpen = true
    }
    this.maxHeight = this.$refs.moreData.offsetHeight
  },
  methods: {
    handleClick () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
<style lang="less" scoped>
  .icon-up{
    i{
      transition: 0.5s;
      transform: rotate(0deg);
      display: inline-block;
    }
  }
  .icon-down{
    i{
      transition: 0.5s;
      transform: rotate(180deg);
      display: inline-block;
    }
  }
  .more-icon{
    height: 64px;
    text-align: center;
    background: #fff;
    i {
      color: #CCCCCC;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .more-data{
    height: 0;
    transition: all 0.5s;
    overflow: hidden;

  }
</style>
